import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_WORKER_USER_LIST',
    url: '/api/hmi_users',
  });
  return [data || [], exec, isRequestSuccessed];
});
